import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToasterUtilService } from '../../../util/toaster-util.service';
import { CadastroModalUtil } from '../../../util/modal/cadastro.modal.util';
import { CustomValidators } from 'ng5-validation';
import { Select2OptionData } from 'ng2-select2';
import { AutenticacaoService } from '../../../service/autenticacao.service';
import { LoginModel } from '../../../routes/login/login.model';
import { UtilService } from '../../../util/util.service';
import { TokenModel } from '../../../util/model/token.model';
import { SessaoUtil } from '../../../util/sessao-util';
import { Router } from '@angular/router';
import { EmpresaService } from '../../../service/empresa.service';

@Component({
  selector: 'app-usuario-temporario',
  templateUrl: './usuario-temporario.component.html',
  styleUrls: ['./usuario-temporario.component.scss'],
  providers:[AutenticacaoService, EmpresaService]
})
export class UsuarioTemporarioComponent implements OnInit {

  entityForm: FormGroup;
  public empresas: Array<Select2OptionData> = [];

  login: LoginModel = new LoginModel();

  constructor(
    private fb: FormBuilder,
    private toasterUtil: ToasterUtilService,
    private cadastroModalUtil: CadastroModalUtil,
    private autenticacaoService: AutenticacaoService,
    private empresaService: EmpresaService,
    private sessaoUtil: SessaoUtil,
    private router: Router
  ) {

   }

  ngOnInit() {
    this.criarFormGroup();
    this.preencheEmpresas();
  }

  criarFormGroup(){
    this.entityForm = this.fb.group({
      login: ['', Validators.required],
      senha: ['', Validators.required],
      empresa: [[]],
    });
  }

  onEntrar(event){
    let error:boolean = false;

    if(UtilService.empty(this.entityForm.controls['login'].value)){
      error = true;
      this.toasterUtil.alerta("Login em branco.");
    }

    if(UtilService.empty(this.entityForm.controls['senha'].value)){
      error = true;
      this.toasterUtil.alerta("Senha em branco.");
    }

    if(UtilService.empty(this.entityForm.controls['empresa'].value)){
      error = true;
      this.toasterUtil.alerta("Empresa em branco.");
    }

    if (error){
      return;
    }

    let login: LoginModel = this.preencheObjeto();

    this.autenticacaoService.validaUsuarioTemporario(login)
                            .then((login: LoginModel) => {
                             if(login != null){
                                 this.autenticacaoService.login(login).then((resp) => this.loginEfetuado(login, resp))
                             }else{
                                 this.toasterUtil.alerta('Login/E-Mail ou senha inválidos.');
                             }
                            }).catch(erro => this.toasterUtil.alerta('Login/E-Mail ou senha inválidos.'));


  }

  onCancelar(event){
    this.cadastroModalUtil.closeModal();
  }

  preencheEmpresas() {
    this.empresaService.retornaEmpresas(this.sessaoUtil.isUsuarioAdministrador() || this.sessaoUtil.isUsuarioAcessoTotal(), this.sessaoUtil.idUsuarioLogado)
                            .then((resp : Array<Select2OptionData>) => {
                                if(resp != undefined && resp != null && resp.length > 0){
                                  for (let index = 0; index < resp.length; index++) {
                                    this.empresas.push(resp[index]);
                                  }
                                }
                            })
                            .catch(erro => this.toasterUtil.erro(erro));
  }

  preencheObjeto() : LoginModel{
    let retorno: LoginModel = new LoginModel();

    retorno.login = UtilService.stringNotNull(this.entityForm.controls['login'].value);
    retorno.senha = UtilService.stringNotNull(this.entityForm.controls['senha'].value);
    
    return retorno;
  }

  loginEfetuado(login: LoginModel, token: TokenModel) {
    if (token != null && token.access_token != undefined && token.access_token != null) {
      this.sessaoUtil.setToken(token);

      this.autenticacaoService.montaSessaoUsuarioTemporario(login, this.sessaoUtil.getToken().access_token).then((resp) => {
                                                                                              resp.token = token;
                                                                                              this.sessaoUtil.preencheDadosSessao(resp);
                                                                                              localStorage.setItem('nfceapi_dadosSessao', btoa(JSON.stringify(resp)));
                                                                                              this.router.navigate(['/dashboard']);
                                                                                              this.cadastroModalUtil.closeModal();
                                                                                             })
                                                                                            .catch(erro => this.toasterUtil.erro(erro));
    } else {
        this.toasterUtil.alerta('Login/E-Mail ou senha inválidos.');
        $('input#senha').focus();
        $('input#senha').select();
        //this.limpaLogin();
    }
}


}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/usuario-temporario/usuario-temporario.component.ts